export const corporate = {
  "hero": {
    "title": "Sobre DONKEY TRAVEL",
    "subtitle": "Descubra a nossa história, a nossa visão e a equipa apaixonada que está a reinventar a troca de casas para os anfitriões mais exigentes."
  },
  "mission": {
    "badge": "Nossa Missão",
    "title": "Democratizando as viagens peer-to-peer premium",
    "description": "A DONKEY TRAVEL foi criada com uma ambição simples: permitir que os melhores hóspedes também desfrutem dos frutos do seu trabalho. Acreditamos que os proprietários de casas excepcionais, com classificação 4,5 e superior, merecem uma plataforma dedicada onde possam negociar as suas propriedades com confiança, sem o atrito financeiro dos aluguéis tradicionais."
  },
  "philosophy": {
    "badge": "Filosofia e Valores",
    "title": "No coração do nosso clube",
    "description": "Não somos apenas uma plataforma, somos uma comunidade construída sobre confiança, respeito mútuo e excelente hospitalidade.",
    "values": {
      "fair": {
        "title": "Equidade",
        "desc": "Nosso sistema de negociação foi projetado para ser justo e transparente. Você oferece tempo em sua acomodação, economiza tempo para viajar. É simples, sem taxas ocultas."
      },
      "local": {
        "title": "Imersão",
        "desc": "A troca de casas é a oportunidade de viver como um morador local, descobrir regiões fora do comum e criar conexões autênticas."
      },
      "community": {
        "title": "Confiar",
        "desc": "Ao reservar o nosso clube para hóspedes com classificação 4,5+, garantimos um nível impecável de exigência e qualidade dentro da nossa rede."
      }
    }
  },
  "team": {
    "badge": "A equipe",
    "title": "Atrás da DONKEY TRAVEL",
    "subtitle": "Uma plataforma nascida da paixão por viagens e hospitalidade.",
    "members": {
      "ceo": {
        "name": "Silvana",
        "role": "Fundador e CEO",
        "bio": "Anfitrião apaixonado há anos, Sylvain imaginou a DONKEY TRAVEL sozinho procurando uma solução para viajar de graça enquanto promovia o seu próprio alojamento. Movido pela vontade de criar o melhor clube de intercâmbio europeu, garante todos os dias a excelência da comunidade."
      }
    }
  },
  "investors": {
    "badge": "Investidores e Parceiros",
    "title": "Junte-se à aventura",
    "description": "A DONKEY TRAVEL está a crescer e estamos sempre abertos a oportunidades estratégicas para acelerar o nosso desenvolvimento em toda a Europa.",
    "cta": "Contate-nos"
  }
};
